import PropTypes from 'prop-types'

const CreativeLinkAfter = ({ after }) => (
  <>
    {after.status && (
      <tr>
        <th scope="row">상태</th>
        <td>
          <div className="inner_cell">{after.status}</div>
        </td>
      </tr>
    )}
  </>
)
export default CreativeLinkAfter

CreativeLinkAfter.propTypes = {
  after: PropTypes.shape({
    status: PropTypes.string,
  }),
}
